import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { ReactNode, useState } from 'react';
import { colors, spacing } from '../../../utils/styleguide';
import IconButton from '../buttons/IconButton';

const ExpandedStyle = () => css`
  background-color: ${colors.blueLighter};
  border-color: ${colors.blue};
`;

const MainWrapper = styled.div<{ isExpanded: boolean }>`
  border: 1px solid ${colors.lightGray};
  border-radius: 8px;
  padding: ${spacing[3]}px ${spacing[2]}px ${spacing[3]}px ${spacing[4]}px;
  cursor: pointer;
  ${({ isExpanded }) => (isExpanded ? ExpandedStyle : null)};
`;

interface ExpandableBoxProps {
  content: ReactNode;
  expandedContent: ReactNode;
  className?: string;
}

const ExpandableBox = ({ content, expandedContent, className }: ExpandableBoxProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <MainWrapper
      onClick={() => setIsExpanded((oldIsExpanded) => !oldIsExpanded)}
      isExpanded={isExpanded}
      role="button"
      className={className}
    >
      <div css={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div>{content}</div>
        <IconButton
          iconName={isExpanded ? 'x-ol' : 'plus'}
          variant="onlyIcon"
          ariaLabel="expand button"
          css={{ marginTop: -3 }}
        />
      </div>
      <div css={{ display: isExpanded ? 'initial' : 'none' }}>{expandedContent}</div>
    </MainWrapper>
  );
};

export default ExpandableBox;
